import * as React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import Homepage from "./pages/homepage.jsx";
import PostAd from "./pages/post-ad.jsx";
import Myads from "./pages/my-ads.jsx";
import PendingAds from "./pages/pending-ads.jsx";
import Removed from "./pages/removed-ads.jsx";
import NewCarPage from "./pages/new-cars";
import VehicleDetails from "./pages/vehicle-details.jsx";
import VehicleInspection from "./pages/vehicle-inspection.jsx";
import BikeInspection from "./pages/bike-inspection.jsx";
import Search from "./pages/search.jsx";
import Inspection from "./pages/inspection.jsx";
import UserInspectionOrders from "./pages/my-orders";
import AdminInspectionOrders from "./pages/inspection-orders";
import Completedorders from "./components/vehicleInspection/admin/completedOrders";
import Bidding from "./pages/bidding";
import Upcomming from "./pages/upcomming";
import BiddingVehicleDetails from "./pages/bidding-vehicle-details";
import MyProfile from "./pages/profile";
import Saved from "./pages/saved-ads.jsx";
import Terms from "./pages/terms";
import Privacy from "./pages/policy";
import About from "./pages/about_us";
import Contact from "./pages/contact_us";
import Refund from "./pages/refund_return";
import FAQ from "./pages/faq";
import Header from "./components/header";
import Footer from "./components/footer";
import Test from "./pages/test";
import BecomeMember from "./pages/become-a-member";
import PaymentHistory from "./pages/payment-history";
import UpcomingVehicleDetails from "./pages/upcoming-vehicle-details";
import ScrollToTop from "./scrollToTop";
import InspectionHistory from "./pages/inspection-history";
import ForgotPassword from "./pages/forgot-password";
import Cookies from "js-cookie";
import { useAuthContext } from "./hooks/useAuthContext";
import ResetPassword from "./components/forgot-password/reset-password";
import Sold from "./pages/sold-ads";
import CarSuggest from "./pages/car-suggest.jsx";
import SubscriberForm from "./components/subscribe/index.jsx";
import SellerAppointment from "./components/bidding/seller-appointment/index.jsx";
import SupportTicket from "./components/supportTicket/index.jsx";
import PendingInspections from "./components/ads/pending-inspections.jsx";
import RecommenderResult from "./components/car-recommender/recommenderResult.jsx";
import CarInsurance from "./components/carInsurance/index.jsx";
import MTMIS from "./components/mtmis-vehicle-information/index.jsx";
import CarRegistration from "./components/carRegistration/index.jsx";
import CarTransfer from "./components/carTransfer/index.jsx";
import CarDealers from "./components/car-dealers/index.jsx";
import DealerProfile from "./components/car-dealers/dealer-profile.jsx";
import AddDealerProfile from "./components/profile/add-dealer-profile.jsx";
import Specifications from "./components/specifications";
import NewCarsList from "./components/new-cars/newCarsList";
import NewCarSpecs from "./components/new-cars/new-car-specs";
import AdCategories from "./pages/AdCategories.jsx";
import NewCarDetails from "./components/new-cars/newCarDetails.jsx";
import WonBidsPage from "./pages/bids-won.jsx";
import LossBidsPage from "./pages/LossBidsPage.jsx";
import ByBidds from "./pages/buy-more-bidds.jsx";
import { AuthContext } from "./context/AuthContext.js";
import ProtextedRoute from "./components/protectedRoutes/index.jsx";
import { baseUrl } from "./api/ipconfig.js";
import axios from "axios";
import { Alert, Snackbar } from "@mui/material";
import ReverseProtectedRoute from "./components/reverseProtection/index.jsx";
import BecomeMemberPayFast from "./pages/become-a-member-payfast.jsx";
import LoginPage from "./components/loginPage/index.jsx";
import TokenAmount from "./components/bidding/token-amount/index.jsx";
import FeatureAd from "./components/feature-add/index.jsx";
import ImportCar from "./pages/car-import.jsx";
import ManagedByFameWheels from "./pages/managed-by-fw.jsx";
import SellThroughFameWheels from "./components/post-ad-body/sell-through.jsx";
import InspectionPkgHistory from "./pages/inspection-package-history.jsx";
import Dashboard from "./pages/dashboard.jsx";
import NumberLoginModal from "./components/loginModal/number.jsx";
import Finance from "./pages/car-finance.jsx";
import UserProfile from "./components/profile/index.jsx";
import SellBikes from "./pages/Sell-Bikes.jsx";
import BikePostad from "./pages/bike-post-ad.jsx";
import BikeSearch from "./pages/bike-search.jsx";
import TokenSender from "./auth/sendToken.jsx";
import BikeDetails from "./pages/bike-details.jsx";
import PayFast from "./components/payfast/index.jsx";
import TplInsurance from "./pages/tpl-insurance.jsx";
import ScanMe from "./pages/scan-me.jsx";
import BoostAd from "./components/boost-ad/index.jsx";
import TapTop from "./components/TapTop/index.jsx";
import PriceCal from "./components/PriceCal/PriceCal.jsx";
import UserSubscription from "./components/usere-subscription/index.jsx";

function App() {
  const { user } = React.useContext(AuthContext);
  const { dispatch } = useAuthContext();
  const token = localStorage.getItem("token");

  const [errorToast, setErrorToast] = React.useState(false);

  const xorEncrypt = (data, key) => {
    const encryptedData = data.split("").map((char, i) => {
      const keyChar = key.charCodeAt(i % key.length);
      const encryptedChar = char.charCodeAt(0) ^ keyChar;
      return String.fromCharCode(encryptedChar);
    });
    return encryptedData.join("");
  };

  let deferredPrompt;

  window.addEventListener("beforeinstallprompt", (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();

    // Save the event for triggering it later
    deferredPrompt = e;

    // Optionally, show an "Install" button in your UI
    document.getElementById("install-btn").style.display = "block";

    document.getElementById("install-btn").addEventListener("click", () => {
      // Show the prompt
      deferredPrompt.prompt();

      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");
        } else {
          console.log("User dismissed the install prompt");
        }
        deferredPrompt = null;
      });
    });
  });

  React.useEffect(() => {
    const checkToken = async () => {
      try {
        const response = await axios.get(`${baseUrl}/checkToken`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response?.status === 200 && response?.data?.success === true) {
          return;
        } else {
          localStorage.clear();
          Cookies.remove("%8564C%27");
          dispatch({ type: "LOGOUT" });

          setErrorToast(true);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (token) {
      checkToken();
    }
  }, [token]);

  React.useEffect(() => {
    const data = Cookies.get("%8564C%27");

    const xorEncrypt = (data, key) => {
      const encryptedData = data.split("").map((char, i) => {
        const keyChar = key.charCodeAt(i % key.length);
        const encryptedChar = char.charCodeAt(0) ^ keyChar;
        return String.fromCharCode(encryptedChar);
      });
      return encryptedData.join("");
    };
    const xorDecrypt = (encryptedData, key) => {
      return xorEncrypt(encryptedData, key); // Since XOR is symmetric, encryption and decryption are the same
    };

    if (data) {
      const decryptedData = xorDecrypt(data, "FameBusiness@214");
      if (data) {
        dispatch({ type: "LOGIN", payload: JSON.parse(decryptedData) });
      }
    } else {
      dispatch({ type: "LOGOUT" });
    }
  }, [dispatch]);

  React.useEffect(() => {
    const androidAppUrl =
      "https://play.google.com/store/apps/details?id=com.famewheels";
    const iosAppUrl =
      "https://apps.apple.com/pk/app/famewheels-cars-live-bidding/id6475592948";

    const showAppDownloadPrompt = () => {
      try {
        const isMobile = /android|iphone|ipad|ipod/i.test(navigator.userAgent); // Check for mobile devices
        const dismissalFlag = localStorage.getItem("hasDismissedAppPrompt");
        const dismissalTimestamp = localStorage.getItem("dismissalTimestamp");
        const currentTime = Date.now();

        const resetTimePeriod = 10 * 60 * 1000; // 10 minutes

        if (!isMobile) {
          return; // Don't show the prompt if not a mobile device
        }

        // If the user dismissed and the reset time has not passed, do not show the prompt
        if (
          dismissalFlag === "true" &&
          dismissalTimestamp &&
          currentTime - parseInt(dismissalTimestamp) < resetTimePeriod
        ) {
          // Don't show the prompt if dismissed within 24 hours
          return;
        }

        // Create overlay and prompt element
        const overlay = document.createElement("div");
        overlay.id = "overlay";
        overlay.style.position = "fixed";
        overlay.style.top = "0";
        overlay.style.left = "0";
        overlay.style.width = "100%";
        overlay.style.height = "100%";
        overlay.style.backgroundColor = "rgba(0, 0, 0, 0.7)"; // Black overlay with light opacity
        overlay.style.zIndex = "9998"; // Behind the prompt
        document.body.appendChild(overlay);

        const prompt = document.createElement("div");
        prompt.id = "app-download-prompt";
        prompt.style.position = "fixed";
        prompt.style.zIndex = "9999";
        prompt.style.bottom = "-100%"; // Initially off-screen
        prompt.style.left = "0";
        prompt.style.width = "100%";
        prompt.style.background = "#fff";
        prompt.style.borderTopLeftRadius = "15px";
        prompt.style.borderTopRightRadius = "15px";
        prompt.style.padding = "15px";
        prompt.style.textAlign = "end";
        prompt.style.transition = "bottom 0.5s ease-in-out"; // Add transition for smooth slide-up
        prompt.innerHTML = `
    <p style="margin: 0; text-align: center; font-weight: 600; font-size: 16px; color: #20409a;">There is more in the app</p>
    <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center; margin-top: 15px;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-left: 10px;">
        <img style="width: 50px; height: 50px; border-radius: 5px; border: 1px solid #ccc;" src="https://www.famewheels.com/android-chrome-192x192.png" alt="Get it on Google Play">
        <p style="margin: 0; font-weight: bold; font-size: 15px; color: #000000; margin-left: 10px;">FameWheels App</p>
      </div>
      <button id="download-app" style="background-color: #b80505; color: white; padding: 10px 15px; border: none; cursor: pointer; font-weight: bold; font-size: 14px; border-radius: 7px; margin-right: 10px;">Open App</button>
    </div>
    <button id="continue-browser" style="text-align: right; background-color: transparent; cursor: pointer; font-size: 14px; color: #20409a; padding: 0px; border: none; font-weight: 600;">Continue in Browser <span style="font-size: 18px;"> > </span></button>
  `;
        document.body.appendChild(prompt);

        setTimeout(() => {
          prompt.style.bottom = "0"; // Animate to the top (visible)
        }, 100);

        // Attach event listeners for buttons
        const downloadButton = document.getElementById("download-app");
        const continueButton = document.getElementById("continue-browser");

        const checkIfAppIsInstalled = () => {
          const isAndroid = /android/i.test(navigator.userAgent);
          const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

          if (isAndroid) {
            const startTime = Date.now();
            const timeout = setTimeout(() => {
              if (Date.now() - startTime < 1000) {
                // Fallback to Play Store if app is not installed
                window.location.href = androidAppUrl;
              }
            }, 500);

            // Try to open the app
            window.location.href = "famewheels://";
          } else if (isIOS) {
            const startTime = Date.now();
            const timeout = setTimeout(() => {
              if (Date.now() - startTime < 1000) {
                // Fallback to App Store if app is not installed
                window.location.href = iosAppUrl;
              }
            }, 500);

            // Try to open the app
            window.location.href = "famewheels://";
          }
        };

        if (downloadButton) {
          downloadButton.onclick = () => {
            // console.log("Download button clicked");
            checkIfAppIsInstalled();
          };
        }

        if (continueButton) {
          continueButton.onclick = () => {
            // Mark the prompt as dismissed and store the dismissal time
            localStorage.setItem("hasDismissedAppPrompt", "true");
            localStorage.setItem("dismissalTimestamp", currentTime.toString());
            overlay.remove();
            prompt.remove();
          };
        }
      } catch (error) {
        console.error("Error showing app download prompt:", error);
      }
    };

    // Show the prompt if app not installed and hasn't been dismissed
    showAppDownloadPrompt();

    // Cleanup on component unmount
    return () => {
      const overlay = document.getElementById("overlay");
      const prompt = document.getElementById("app-download-prompt");
      if (overlay) overlay.remove();
      if (prompt) prompt.remove();
    };
  }, []);

  React.useEffect(() => {
    const getUserAgain = async () => {
      const userResponse = await axios.get(`${baseUrl}/getUser`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const encryptedUserData = xorEncrypt(
        JSON.stringify(userResponse.data),
        "FameBusiness@214"
      );
      Cookies.set("%8564C%27", encryptedUserData, {
        expires: 7,
      });

      await dispatch({ type: "LOGIN", payload: userResponse.data });
    };
    if (token) {
      getUserAgain();
    }
  }, []);

  return (
    <>
      <Router>
        <Snackbar
          open={errorToast}
          autoHideDuration={5000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity="error" sx={{ width: "100%" }}>
            Session Expired!
          </Alert>
        </Snackbar>

        <Header />
        <ScrollToTop />
        <Switch>
          <Route exact path="/" component={withRouter(Homepage)} />
          <Route
            exact
            path="/login"
            render={() => <ReverseProtectedRoute Component={LoginPage} />}
          />
          <Route
            exact
            path="/login2"
            render={() => (
              <ReverseProtectedRoute Component={NumberLoginModal} />
            )}
          />

          <Route path="/price-calculator" component={withRouter(PriceCal)} />

          <Route
            path="/post-ad"
            render={() => <ProtextedRoute Component={PostAd} />}
          />
          <Route
            path="/used-bikes/post-ad"
            render={() => <ProtextedRoute Component={BikePostad} />}
          />

          <Route path="/ad-category" component={AdCategories} />
          <Route path="/uashtosd" component={TokenSender} />
          <Route path="/used-bikes/sell" component={SellBikes} />
          <Route
            path="/my-ads"
            render={() => <ProtextedRoute Component={Myads} />}
          />
          <Route
            path="/managed-by-famewheels"
            render={() => <ProtextedRoute Component={ManagedByFameWheels} />}
          />
          {/* <Route path="/used-cars" component={withRouter(UsedCarsPage)} /> */}
          <Route path="/new-cars" component={withRouter(NewCarPage)} />
          <Route
            path="/pending-ads"
            render={() => <ProtextedRoute Component={PendingAds} />}
          />
          <Route
            path="/rejected-ads"
            render={() => <ProtextedRoute Component={Removed} />}
          />
          <Route
            path="/my-saved-ads"
            render={() => <ProtextedRoute Component={Saved} />}
          />
          <Route
            path="/my-sold-ads"
            render={() => <ProtextedRoute Component={Sold} />}
          />
          <Route
            path="/new-car/specifications"
            component={withRouter(Specifications)}
          />
          <Route
            path="/vehicle-details"
            component={withRouter(VehicleDetails)}
          />
          <Route path="/bike-details" component={withRouter(BikeDetails)} />
          <Route
            path="/upcoming-vehicle-details"
            component={withRouter(UpcomingVehicleDetails)}
          />
          <Route
            path="/car-inspection"
            component={withRouter(VehicleInspection)}
          />
          <Route
            path="/bike-inspection"
            component={withRouter(BikeInspection)}
          />
          <Route path="/search" component={withRouter(Search)} />
          <Route path="/inspection" component={withRouter(Inspection)} />
          <Route path="/bike-search" component={withRouter(BikeSearch)} />
          {/* <Route path="/bidding" component={withRouter(LiveBidding)} /> */}
          <Route
            path="/car-recommender"
            component={withRouter(RecommenderResult)}
          />
          <Route
            path="/my-orders"
            render={() => <ProtextedRoute Component={UserInspectionOrders} />}
          />
          <Route
            path="/inspection-orders"
            render={() => <ProtextedRoute Component={AdminInspectionOrders} />}
          />
          <Route
            path="/completed-orders"
            render={() => <ProtextedRoute Component={Completedorders} />}
          />
          <Route
            path="/buy-more-bidds"
            render={() => <ProtextedRoute Component={ByBidds} />}
          />
          <Route path="/dev-bidding" component={withRouter(Bidding)} />
          <Route path="/dev-upcoming" component={withRouter(Upcomming)} />
          <Route
            path="/bidding-vehicle-details"
            component={withRouter(BiddingVehicleDetails)}
          />
          <Route
            path="/dashboard"
            render={() => <ProtextedRoute Component={Dashboard} />}
          />
          <Route
            path="/profile"
            render={() => <ProtextedRoute Component={MyProfile} />}
          />
          <Route path="/user-profile/" component={withRouter(UserProfile)} />

          <Route
            path="/won-bids"
            render={() => <ProtextedRoute Component={WonBidsPage} />}
          />
          <Route
            path="/loss-bids"
            render={() => <ProtextedRoute Component={LossBidsPage} />}
          />
          <Route path="/terms" component={withRouter(Terms)} />
          <Route path="/policy" component={withRouter(Privacy)} />
          <Route path="/scan-me" component={withRouter(ScanMe)} />
          <Route path="/about_us" component={withRouter(About)} />
          <Route path="/contact_us" component={withRouter(Contact)} />
          <Route path="/refund_return" component={withRouter(Refund)} />
          <Route path="/faq" component={withRouter(FAQ)} />
          <Route path="/test" component={withRouter(Test)} />
          <Route path="/tpl-insurance" component={withRouter(TplInsurance)} />
          <Route
            path="/become-a-member"
            component={withRouter(BecomeMemberPayFast)}
          />
          <Route
            path="/become-a-member-payfast"
            component={withRouter(BecomeMember)}
          />
          <Route
            path="/payment-history"
            render={() => <ProtextedRoute Component={PaymentHistory} />}
          />
          {/* <Route
            path="/bidding-requests"
            render={() => <ProtextedRoute Component={BiddingRequests} />}
          /> */}
          <Route
            path="/inspection-history"
            render={() => <ProtextedRoute Component={InspectionHistory} />}
          />
          <Route
            path="/inspection-package-history"
            render={() => <ProtextedRoute Component={InspectionPkgHistory} />}
          />

          <Route
            path="/forgot-password"
            component={withRouter(ForgotPassword)}
          />
          <Route path="/reset-password" component={withRouter(ResetPassword)} />

          <Route path="/car-suggest" component={withRouter(CarSuggest)} />
          <Route path="/subscribe" component={withRouter(SubscriberForm)} />
          <Route
            path="/sell-through-live-bidding"
            component={SellerAppointment}
          />
          <Route path="/user-subscribe" component={UserSubscription} />
          <Route
            path="/sell-through-famewheels"
            component={SellThroughFameWheels}
          />
          <Route
            path="/submit-ticket"
            render={() => <ProtextedRoute Component={SupportTicket} />}
          />
          <Route
            path="/inspection-draft"
            render={() => <ProtextedRoute Component={PendingInspections} />}
          />
          <Route path="/car-finance" component={withRouter(Finance)} />
          <Route path="/car-insurance" component={withRouter(CarInsurance)} />
          <Route path="/car-import" component={withRouter(ImportCar)} />
          <Route
            path="/mtmis-online-vehicle-verification"
            component={withRouter(MTMIS)}
          />
          <Route
            path="/car-registration"
            component={withRouter(CarRegistration)}
          />
          <Route path="/car-transfer" component={withRouter(CarTransfer)} />
          <Route
            path="/add-dealer"
            render={() => <ProtextedRoute Component={AddDealerProfile} />}
          />
          <Route path="/car-dealers" component={withRouter(CarDealers)} />
          <Route path="/dealer/" component={withRouter(DealerProfile)} />
          <Route path="/new-cars-list/" component={withRouter(NewCarsList)} />
          <Route path="/new-car-specs/" component={withRouter(NewCarSpecs)} />
          <Route
            path="/new-car-detail/"
            component={withRouter(NewCarDetails)}
          />
          {/* <Route
            path="/bidding_agreement/"
            render={() => <ProtextedRoute Component={BiddingAgreement} />}
          /> */}
          <Route
            path="/token-payment/"
            render={() => <ProtextedRoute Component={TokenAmount} />}
          />
          <Route
            path="/feature-ad/"
            render={() => <ProtextedRoute Component={FeatureAd} />}
          />
          <Route
            path="/boost-ad/"
            render={() => <ProtextedRoute Component={BoostAd} />}
          />

          <Route path="/PayFast" component={withRouter(PayFast)} />
        </Switch>

        <Footer />
        <TapTop />
      </Router>
    </>
  );
}

export default App;
